import Svg from './Svg'
import HomebotIcon from './Svgs/HomebotIcon.svg'
import BudgetRightArrow from './Svgs/BudgetRightArrow.svg.jsx'
import Check from './Svgs/Check.svg.jsx'
import Chart from './Svgs/Chart.svg.jsx'
import Dog from './Svgs/Dog.svg.jsx'
import LightBulb from './Svgs/LightBulb.svg.jsx'
import Gear from './Svgs/Gear.svg.jsx'
import GreenMoneyBag from './Svgs/GreenMoneyBag.svg.jsx'
import OrangeMoneyBag from './Svgs/OrangeMoneyBag.svg.jsx'
import Rabbit from './Svgs/Rabbit.svg.jsx'
import SnowflakeCool from './Svgs/SnowflakeCool.svg.jsx'
import Thumb from './Svgs/Thumb.svg.jsx'
import Turtle from './Svgs/Turtle.svg.jsx'
import Pencil from './Svgs/Pencil.svg.jsx'
import ExclamationTriangle from './Svgs/ExclamationTriangle.svg'
import Envelope from './Svgs/Envelope.svg'
import Chevron from './Svgs/Chevron.svg.jsx'
import Times from './Svgs/Times.svg.jsx'
import Lock from './Svgs/Lock.svg.jsx'
import Exclamation from './Svgs/Exclamation.svg.tsx'
import ExclamationWithCircle from './Svgs/ExclamationWithCircle.svg.tsx'
import Wand from './Svgs/Wand.svg.tsx'

export {
  HomebotIcon,
  BudgetRightArrow,
  Check,
  Chart,
  Dog,
  LightBulb,
  Gear,
  GreenMoneyBag,
  OrangeMoneyBag,
  Rabbit,
  SnowflakeCool,
  Thumb,
  Turtle,
  Pencil,
  ExclamationTriangle,
  Envelope,
  Chevron,
  Times,
  Lock,
  Exclamation,
  ExclamationWithCircle,
  Wand,
}

export default Svg
